import { Container, IconContainer, LabelContainer, StyledTypography } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { sizeToTitleFontSize, sizeToSubtitleFontSize } from './utils/sizing.js';

function IconWithLabel(props) {
  var title = props.title,
    subtitle = props.subtitle,
    _props$size = props.size,
    size = _props$size === void 0 ? '2xl' : _props$size,
    className = props.className,
    _props$alignment = props.alignment,
    alignment = _props$alignment === void 0 ? 'horizontal' : _props$alignment,
    _props$truncate = props.truncate,
    truncate = _props$truncate === void 0 ? true : _props$truncate,
    children = props.children;
  return /*#__PURE__*/jsxs(Container, {
    className: className,
    $alignment: alignment,
    $size: size,
    children: [/*#__PURE__*/jsx(IconContainer, {
      $size: size,
      children: children
    }), /*#__PURE__*/jsxs(LabelContainer, {
      $size: size,
      $alignment: alignment,
      children: [title && /*#__PURE__*/jsx(StyledTypography, {
        $truncate: truncate,
        $appearance: "300",
        $fontSize: sizeToTitleFontSize[size],
        $lineHeight: "neutralized",
        $fontWeight: "medium",
        children: title
      }), subtitle && /*#__PURE__*/jsx(StyledTypography, {
        $truncate: truncate,
        $appearance: "100",
        $fontSize: sizeToSubtitleFontSize[size],
        $lineHeight: "neutralized",
        $fontWeight: "regular",
        children: subtitle
      })]
    })]
  });
}

export { IconWithLabel };
